import candacePic from "@/public/images/artists/candace.png";
import { Artist } from "@/types/types";

export const candace = {
  id: "263",
  name: "Candace",
  image: candacePic,
  description: `Candace's voice is rich and velvety, sitting low with a smooth, smoky warmth. She layers her tone with effortless control and emotional detail, creating phrases that feel slow-burning and intimate. `,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcandace-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Pop", "RnB", "Soul"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 53,
        high: 73,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
